import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { query } from "utils/general";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import { useField } from "formik";

const Input = styled(TextField)({
  width: "27%",
  margin: "0 3%",
});

const validator = (value, option) => {
  const minVal = parseFloat(option?.min_value, 10);
  const maxVal = parseFloat(option?.max_value, 10);
  const min = Number.isNaN(minVal) ? 0 : minVal;
  const max = Number.isNaN(maxVal) ? 99999 : maxVal;
  if (value > max || value < min) {
    return `(${min} - ${max})`;
  }
};

const InputOption = ({ option }) => {
  const [field, meta, helpers] = useField({
    name: option.code,
    validate: (val) => validator(val, option),
  });
  const { name, type_code } = option;
  const suffix = type_code === "amount" ? "st" : "cm";

  useEffect(() => {
    if (type_code === "amount") {
      helpers.setValue(1);
    }
    const h = query.getNumber("height") / 10;
    const w = query.getNumber("width") / 10;
    console.log({ w, h });
    if (type_code === "height" && h) {
      helpers.setValue(h);
    }
    if (type_code === "width" && w) {
      helpers.setValue(w);
    }
  }, [type_code]);

  useEffect(() => {
    if (option?.default_value) {
      helpers.setValue(option.default_value);
    }
  }, [option, helpers]);

  return (
    <Input
      InputProps={{
        endAdornment: <InputAdornment position="end">{suffix}</InputAdornment>,
      }}
      inputProps={{
        ...field,
        name: option.code,
        value: field.value ? field.value : "",
        onBlur: (e) => {
          console.log(e.target?.value);
          if (!validator(e.target?.value, option)) {
            helpers.setTouched(true);
          } else {
            helpers.setTouched(false);
          }
        },
      }}
      type="number"
      error={meta.error}
      helperText={meta.error}
      label={name}
    />
  );
};

export default InputOption;
